import React, { useEffect, useState } from "react";
import { visionMissionApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./vision-mission.scss";

const defaultData = {
  _id: null, PageTitle: "Vision & Mission", VisionSubtitle: "", VisionContent: "", MissionSubtitle: "", MissionContent: "",
};

const VisionMission = () => {
  const [formData, setFormData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(visionMissionApi);
      const result = await response.json();
      if (response.ok && result.data) {
        const fetchedData = Array.isArray(result.data) ? result.data[0] : result.data;
        if (fetchedData) {
          setFormData(fetchedData);
        }
      }
    } catch (error) {
      console.error("Error fetching Vision & Mission data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${visionMissionApi}/${formData._id}` : visionMissionApi;
      
      console.log(`[Frontend] Submitting ${method} to ${url}`);
      console.log('[Frontend] Payload:', formData);

      const response = await apiClient(url, {
        method,
        body: JSON.stringify(formData),
      });

      console.log(`[Frontend] Response Status: ${response.status} ${response.statusText}`);
      const result = await response.json();
      console.log('[Frontend] Response Body:', result);

      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        fetchData();
      } else {
        console.error('[Frontend] Save failed with status:', response.status);
      }
    } catch (error) {
      console.error("Error saving Vision & Mission data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vm-page">
      <div className="vm-page__header">
        <div><h1>Vision & Mission</h1><p>Define and manage the core values, aspirations, and goals of the institution for public display.</p></div>
        <button className="save-btn" type="submit" form="vmForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Save Changes"}</button>
      </div>

      <form id="vmForm" className="vm-form" onSubmit={handleSubmit}>
        <div className="vm-card">
          <div className="form-section-label">General Configuration</div>
          <div className="form-group"><label>Display Title</label><input type="text" name="PageTitle" value={formData.PageTitle || ""} onChange={handleChange} placeholder="e.g. Vision & Mission" required /></div>
          
          <div className="form-section-separator"></div>

          <div className="vm-grid">
            <div className="vm-section">
              <div className="form-section-label">Institutional Vision</div>
              <div className="form-group"><label>Vision Subtitle</label><input type="text" name="VisionSubtitle" value={formData.VisionSubtitle || ""} onChange={handleChange} placeholder="e.g. Our Future Perspective" /></div>
              <div className="form-group"><label>Vision Narrative</label><textarea name="VisionContent" rows="12" value={formData.VisionContent || ""} onChange={handleChange} placeholder="Describe the long-term vision of the college..." required /></div>
            </div>

            <div className="vm-section">
              <div className="form-section-label">Institutional Mission</div>
              <div className="form-group"><label>Mission Subtitle</label><input type="text" name="MissionSubtitle" value={formData.MissionSubtitle || ""} onChange={handleChange} placeholder="e.g. Our Commitment" /></div>
              <div className="form-group"><label>Mission Narrative</label><textarea name="MissionContent" rows="12" value={formData.MissionContent || ""} onChange={handleChange} placeholder="Describe the mission and objectives of the college..." required /></div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default VisionMission;